<template>
  <div class="offwork-time-picker" role="group" :aria-label="label">
    <span class="time-label">{{ shortLabel }}</span>
    <div class="time-parts">
      <v-select
        :value="hour"
        :items="hourOptions"
        :aria-label="`${label}小時`"
        :menu-props="menuProps"
        dense
        outlined
        hide-details
        background-color="white"
        class="time-part hour-part"
        @change="updateHour"
      />
      <span class="time-colon">:</span>
      <v-select
        :value="minute"
        :items="minuteOptions"
        :aria-label="`${label}分鐘`"
        :menu-props="menuProps"
        :disabled="hour === '24'"
        dense
        outlined
        hide-details
        background-color="white"
        class="time-part minute-part"
        @change="updateMinute"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'OffworkTimePicker',
  props: {
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    allowEndOfDay: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    shortLabel() {
      return this.label.replace('時間', '')
    },
    hour() {
      return this.value.split(':')[0]
    },
    minute() {
      return this.value.split(':')[1]
    },
    hourOptions() {
      const lastHour = this.allowEndOfDay ? 24 : 23
      return Array.from({ length: lastHour + 1 }, (_, hour) => this.pad(hour))
    },
    minuteOptions() {
      return Array.from({ length: 12 }, (_, index) => this.pad(index * 5))
    },
    menuProps() {
      return { maxHeight: 320 }
    }
  },
  methods: {
    pad(value) {
      return String(value).padStart(2, '0')
    },
    updateHour(hour) {
      const minute = hour === '24' ? '00' : this.minute
      this.$emit('input', `${hour}:${minute}`)
    },
    updateMinute(minute) {
      this.$emit('input', `${this.hour}:${minute}`)
    }
  }
}
</script>

<style scoped lang="scss">
.offwork-time-picker {
  width: 100%;
}

.time-label {
  display: block;
  margin-bottom: 4px;
  color: #68747d;
  font-size: 11px;
  font-weight: 600;
}

.time-parts {
  display: grid;
  grid-template-columns: minmax(66px, 1fr) auto minmax(66px, 1fr);
  align-items: center;
  gap: 5px;
}

.time-colon {
  color: #53606a;
  font-size: 16px;
  font-weight: 700;
}

.time-part ::v-deep .v-select__selections {
  justify-content: center;
}

.time-part ::v-deep .v-input__append-inner {
  margin-left: 0;
}
</style>
